import React from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage} from "react-intl";

import {Box} from "@mui/material";

import {black500, greyishBlue200, greyishBlue500, greyishBlue600} from "assets/jss/main";

ProductDescription.propTypes = {
    brand: PropTypes.string,
    name: PropTypes.string,
    sku: PropTypes.string,
};

function ProductDescription({brand, name, sku}) {
    return (
        <Box sx={{ display: "flex", flexDirection: "column", gap: "8px", justifyContent: "center" }}>
            <div style={{
                fontSize: "14px",
            }}>
                <div style={{color: greyishBlue600}}>
                    {brand}
                </div>
                <div style={{
                    fontWeight: 600,
                    color: black500,
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    display: "-webkit-box",
                    WebkitLineClamp: 2,
                    WebkitBoxOrient: "vertical",
                }}>
                    {name ?? sku}
                </div>
            </div>


            {sku && (
                <div style={{ display: "flex", alignItems: "center", gap: "4px", whiteSpace: "nowrap" }}>
                    <span style={{ fontSize: "14px", color: greyishBlue500 }}><FormattedMessage id='dashboard.common.ref' /></span>
                    <span style={{ fontSize: "14px", color: greyishBlue200 }}>:</span>
                    <span style={{ fontSize: "14px", color: greyishBlue500 }}>{sku}</span>
                </div>
            )}
        </Box>
    );
}

export default ProductDescription;
